import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('economicGraph', economicGraph);

/* @ngInject */
function economicGraph(GraphService, locale, defaultGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(defaultGraph(), {
        options: {
            chart: {
                type: 'column',
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    pointPadding: 0.075,
                    groupPadding: 0.1,
                    borderWidth: 0
                }
            },
            tooltip: GraphService.getTooltipFormatterWithMultipleTotals(['graph.actual_total', 'graph.scenario_total'], [[0, 1, 2, 3, 4], [5, 6]]),
        },
        xAxis: {
            type: 'datetime',
            labels: {formatter: GraphService.datetimeLabeler()},
            gridLineColor: 'rgba(255, 255, 255, 0.0)',
            gridLineWidth: 32,
            minorGridLineColor: 'rgba(255, 255, 255, 0.0)',
            minorGridLineWidth: 32,
            minorTickLength: 0,
            minorTickInterval: 'auto'
        },
        yAxis: [
            {
                title: {
                    text: '',
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 13
                },
                gridLineWidth: 0,
                plotLines: [
                    {
                        color: GraphService.colors.lightGrey,
                        value: 0,
                        width: 1,
                    }
                ],
                showFirstLabel: true
            }
        ],
        series: [
            {
                name: locale.getString('economic.from_grid_costs'),
                stack: 'actual',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.lightBlue3}),
                },
                color: GraphColors.blue,
                states: {
                    hover: {
                        color: GraphColors.lightBlue3
                    }
                },
                index: 0,
                visible: false,
                data: []
            },
            {
                name: locale.getString('economic.to_grid_costs'),
                stack: 'actual',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.lightBlue}),
                },
                color: GraphColors.blue,
                states: {
                    hover: {
                        color: GraphColors.lightBlue
                    }
                },
                index: 1,
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.genset_costs'),
                stack: 'actual',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.lightBlue2}),
                },
                color: GraphColors.blue,
                states: {
                    hover: {
                        color: GraphColors.lightBlue2
                    }
                },
                index: 2,
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.solar_maintenance_costs'),
                stack: 'actual',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.lightBlue4}),
                },
                color: GraphColors.blue,
                states: {
                    hover: {
                        color: GraphColors.lightBlue4
                    }
                },
                index: 3,
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.genset_maintenance_costs'),
                stack: 'actual',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.lightBlue5}),
                },
                color: GraphColors.blue,
                states: {
                    hover: {
                        color: GraphColors.lightBlue5
                    }
                },
                index: 4,
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.compare_costs'),
                stack: 'compare',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.lightGrey}),
                },
                color: GraphColors.grey,
                states: {
                    hover: {
                        color: GraphColors.lightGrey
                    }
                },
                index: 5,
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.compare_maintenance'),
                stack: 'compare',
                tooltip: {
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.grey}),
                },
                color: GraphColors.grey,
                states: {
                    hover: {
                        color: GraphColors.grey
                    }
                },
                index: 6,
                visible: false,
                data: []
            },
        ]
    });
}
